import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors } from "../../../components/01_config/Colors";

const Wrapper = styled.div`
    max-width: 800px;
    display: flex;
    justify-content: center;
    gap: 30px;
    margin: 0 auto;
    flex-wrap: wrap;
`

const Card = styled(Link)`
    position: relative;
    width: 200px;
    height: 200px;
    padding: 20px 0;
    background-color: ${colors.greyLight};
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    text-decoration: none;
    &:active {
        transform: translate(2px, 2px);
    }
`

const Image = styled.img`
    height: ${({index}) => index===0 ? "60px" : "80px"};
`

const Lesson = styled.div`
    color: black;
    font-size: 20px;
    font-weight: bold;
    white-space: pre-line;
    text-align: center;
`
const Subtitle = styled(Lesson)`
    margin-top: 5px;
    font-size: 18px;
    color: ${colors.mainDark};
`

export { Wrapper, Card, Image, Lesson, Subtitle }